import { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { View, ViewOff } from '@carbon/icons-react';

const MaskedDisplay = ({ value, showLastXDigits }) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!value) {
    return null;
  }

  const toggleVisibility = (e) => {
    e?.stopPropagation?.();
    setIsVisible(!isVisible);
  };

  const maskedValue =
    showLastXDigits && showLastXDigits < value.length
      ? '•'.repeat(value.length - showLastXDigits) + value.slice(-showLastXDigits)
      : '•'.repeat(value.length);

  return (
    <span className="inline-flex items-center gap-2 align-middle">
      <span className="font-mono tracking-wider">{isVisible ? value : maskedValue}</span>

      <Tooltip title={isVisible ? 'Hide' : 'Show'}>
        <Button
          type="text"
          size="small"
          onClick={toggleVisibility}
          icon={isVisible ? <ViewOff size={16} /> : <View size={16} />}
          className="h-min"
        />
      </Tooltip>
    </span>
  );
};

export default MaskedDisplay;
